<template>
  <div>
    <v-row>
      <v-col v-if="!group.isBuiltin" cols="12">
        <v-card>
          <v-card-title>Langues </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row
              v-if="
                group.portalConfiguration.languages != null &&
                group.portalConfiguration.languages.length > 0
              "
            >
              <v-col cols="12" md="2">
                <v-select
                  label="Langue par défault"
                  v-model="group.portalConfiguration.default_language"
                  :items="group.portalConfiguration.languages"
                  :rules="rules.default_languageRules"
                  :loading="loadingLanguages"
                  :disabled="!isGrantedUser()"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <div>Langues disponibles</div>
                <v-layout row wrap class="px-3">
                  <div
                    class="inline-block mr-2"
                    v-for="(language, index) in group.portalConfigurationModel
                      .languages"
                    :key="index"
                  >
                    <v-checkbox
                      :rules="rules.languagesRules"
                      :key="language"
                      v-model="group.portalConfiguration.languages"
                      :label="language.toUpperCase()"
                      :value="language"
                      :disabled="
                        !isGrantedUser() ||
                        (group.portalConfiguration.languages.length == 1 &&
                          group.portalConfiguration.languages[0] == language)
                      "
                    ></v-checkbox>
                  </div>
                </v-layout>
                <v-progress-linear
                  indeterminate
                  rounded
                  v-if="loadingLanguages"
                ></v-progress-linear>
              </v-col>
            </v-row>
            <confirm-dialog
              :open.sync="openConfirmDialog"
              :loading="loadingLanguages"
              v-on:cancel="cancelLanguagesChanges"
              v-on:confirm="updateLanguages(group.id)"
            >
              <template #title> Demande de confirmation </template>
              <slot name="confirm-text">
                Êtes-vous sûr.e de vouloir changer cette valeur ?
              </slot>
            </confirm-dialog>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-else>
        <v-alert type="warning">
          La traduction ne peut pas être surchargée au niveau GROUPE quand
          celui-ci a un template prédéfini.
        </v-alert>
      </v-col>
    </v-row>
    <group-portal-translation
      v-if="
        group.portalConfiguration.languages != null &&
        group.portalConfiguration.languages.length > 0 &&
        !group.isBuiltin
      "
      :languages="group.portalConfiguration.languages"
    ></group-portal-translation>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  ref,
  toRefs,
  watch,
} from "@vue/composition-api";
import { useGroup } from "@/composables/group";
import global from "@/composables/global";
import ConfirmDialog from "@/components/General/ConfirmDialog.vue";
import GroupPortalTranslation from "@/components/Group/GroupPortalTranslation";
import { useRoles } from "../../composables/roles";

export default defineComponent({
  components: {
    ConfirmDialog,
    GroupPortalTranslation,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* Import des API */
    const { data, updatePortalConfigurationSparse } = useGroup();

    /* Cycle de vie */
    onMounted(() => {
      originalLanguages.defaultLanguage =
        props.group.portalConfiguration.default_language;
      originalLanguages.selectedLanguages =
        props.group.portalConfiguration.languages;
    });

    /* Variables */
    const originalLanguages = {
      selectedLanguages: [],
      defaultLanguage: "",
    };
    const loadingLanguages = ref(false);
    const openConfirmDialog = ref(false);
    const { isGrantedUser } = useRoles();

    /* Méthodes */
    const updateLanguages = async function (id) {
      loadingLanguages.value = true;
      const formData = {
        default_language: props.group.portalConfiguration.default_language,
        languages: props.group.portalConfiguration.languages,
      };
      await updatePortalConfigurationSparse(String(id), formData);
      originalLanguages.defaultLanguage =
        props.group.portalConfiguration.default_language;
      originalLanguages.selectedLanguages =
        props.group.portalConfiguration.languages;
      loadingLanguages.value = false;
    };
    const cancelLanguagesChanges = function () {
      openConfirmDialog.value = true;
      props.group.portalConfiguration.default_language =
        originalLanguages.defaultLanguage;
      props.group.portalConfiguration.languages =
        originalLanguages.selectedLanguages;
    };
    const areEquals = function (a, b) {
      if (a && b) {
        let result = true;
        let first = a;
        let second = b;

        if (a.length < b.length) {
          first = b;
          second = a;
        }

        for (let i = 0; i < first.length; i++) {
          if (second.indexOf(first[i]) < 0) {
            result = false;
            break;
          }
        }

        return result;
      } else {
        return true;
      }
    };

    /* Watchers */
    watch(
      () => props.group.portalConfiguration.default_language,
      (newValue, oldValue) => {
        if (
          newValue &&
          newValue != originalLanguages.defaultLanguage &&
          oldValue &&
          !loadingLanguages.value &&
          global.selectedAppTab == 4
        ) {
          openConfirmDialog.value = true;
        } else {
          openConfirmDialog.value = false;
        }
      },
      { deep: true }
    );
    watch(
      () => props.group.portalConfiguration.languages,
      (newValue, oldValue) => {
        if (!areEquals(newValue, oldValue) && !openConfirmDialog.value) {
          openConfirmDialog.value = true;
        } else {
          openConfirmDialog.value = false;
        }
      },
      { deep: true }
    );

    return {
      updateLanguages,
      cancelLanguagesChanges,
      ...toRefs(data),
      loadingLanguages,
      openConfirmDialog,
      isGrantedUser,
    };
  },
});
</script>
